module.exports = __webpack_public_path__ + "img/straight_line_icon_123.9f9ff0ab.svg";